"use client"

import type React from "react"
import { useState } from "react"
import { useHistory } from "react-router-dom"
import { Button, TextField, Box, Typography, CircularProgress } from "@mui/material"
import { Check, Close } from "@mui/icons-material"
// import { updateLeaveStatus } from "../../Services/LeaveService"
import styles from "./LeaveStatusActions.module.css"
import { updateLeaveStatus } from "../../api/LeaveService"

interface LeaveStatusActionsProps {
  leaveId: string
  employeeId: string
}

const LeaveStatusActions: React.FC<LeaveStatusActionsProps> = ({ leaveId, employeeId }) => {
  const history = useHistory()
  const [comments, setComments] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleStatusUpdate = async (status: "approved" | "rejected") => {
    setIsSubmitting(true)

    try {
      await updateLeaveStatus({
        leaveId,
        employeeId,
        status,
        comments,
      })

      // Refresh the page to show updated status
      // window.location.reload()
      history.push('/folder/manage-leaaves/Manage%20leaves')
    } catch (error) {
      console.error("Failed to update leave status:", error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className={styles.container}>
      <Box className={styles.commentsSection}>
        <Typography variant="body2" gutterBottom className={styles.commentsLabel}>
          Comments (Optional)
        </Typography>
        <TextField
          multiline
          rows={3}
          placeholder="Add any comments or notes about this decision"
          fullWidth
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          variant="outlined"
          size="small"
          className={styles.commentsField}
        />
      </Box>

      <Box className={styles.buttonsContainer}>
        <Button
          variant="contained"
          color="success"
          fullWidth
          onClick={() => handleStatusUpdate("approved")}
          disabled={isSubmitting}
          className={styles.approveButton}
          startIcon={<Check />}
        >
          {isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Approve Leave"}
        </Button>

        <Button
          variant="outlined"
          color="error"
          fullWidth
          onClick={() => handleStatusUpdate("rejected")}
          disabled={isSubmitting}
          className={styles.rejectButton}
          startIcon={<Close />}
        >
          {isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Reject Leave"}
        </Button>
      </Box>
    </div>
  )
}

export default LeaveStatusActions
